<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer :loading = "loading">
			<template #default>
				<div ref="logistictrace_custom_form" style="box-sizing: border-box;padding: 20px;"></div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="danger" content="清除" @click="del"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "el-divider",
					"children": [
						"表单配置"
					]
				},
				{
					"type": "$emun",
					"field": "city",
					"title": "默认省市区",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"name":"city",
						"cascader":true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "companyaccount",
					"title": "默认收款账户",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"打印配置"
					]
				},
				{
					"type": "$input",
					"field": "offerphone",
					"title": "报价单联系人",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {

					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "contractphone",
					"title": "合同联系人",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
				
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"推送配置"
					]
				},
				{
					"type": "$select",
					"field": "shop",
					"title": "推送店铺",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "account",
					"title": "默认结算账户",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"关闭配置"
					]
				},
				{
					"type": "$select",
					"field": "errorType",
					"title": "异常原因",
					"value": null,
					"hidden": false,
					"options":[],
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "errorRemark",
					"title": "追加备注",
					"value": "云系统关闭",
					"hidden": false,
					"options":[],
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading:false,
				configmodule:'offer',
				modal_model:false,
				modal_title: '报价单配置',
				modal_width:800,
				modal_height:600,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {			
			modal_init(){
				this.sourceData = (this.data && this.data.config) ? JSON.parse(JSON.stringify(this.data.config)) : null
				this.sourceData.city = (this.sourceData.city && Array.isArray(this.sourceData.city)) ? this.sourceData.city.map((item)=>{
					return parseInt(item)
				}):null
				// console.log(this.sourceData,123123)
				
				this.loading = true
				this.$api.offer.getconfigoptions().then((res)=>{
					let formData = JSON.parse(JSON.stringify(formjson))
					let rule = formData.rule.rule
					rule.forEach((item)=>{
						if(item.field == 'shop'){
							item.options = res.shop.map((_item)=>{
								return {value:_item.shopUid,label:_item.showName}
							})
						}
						if(item.field == 'account'){
							item.options = res.account.map((_item)=>{
								return {
									value:_item.acc_uid,
									label:_item.acc_name+ '【'+_item.inst_account+'】',
								}
							})
						}
						if(item.field == 'companyaccount'){
							item.options = res.account.map((_item)=>{
								return {
									value:_item.inst_account,
									label:_item.acc_name+ '【'+_item.inst_account+'】',
								}
							})
						}
						if(item.field == 'errorType'){
							item.options = res.errorType.map((_item)=>{
								return {value:_item.id,label:_item.label}
							})
						}
					})
					let option = formData.rule.option
					option.el = this.$refs.logistictrace_custom_form
					this.fApi = this.$formCreate(rule, option)
					this.fApi.nextTick(() => {
						this.regestevent(rule)
						this.setFormData()		
					})
					this.loading = false
					this.$emit('show')
				},()=>{
					this.loading = false
				})

			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			del(){
				this.$confirm('是否确认清除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.config.delete(0,{module:this.configmodule}).then(()=>{
						this.loading = false
						this.fApi.resetFields()
						this.$message.success('操作成功')
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					this.$api.config.save({module:this.configmodule,config:submitData}).then(()=>{
						this.$message.success('操作成功')
						this.$emit('success')
						this.modal_cancel()
					})
					// this.$api.logistictrace.updatefromlist(this.row.traceID,submitData).then(()=>{
					// 	this.$emit('success')
					// 	this.modal_cancel()
					// })
					console.log(submitData)
					// this.getgrid().validate(true, (res) => {
					// 	if (!res) {
					// 		let submitData = JSON.parse(JSON.stringify(formData))
					// 		this.submitDataFormater(submitData)
					// 		let detail = this.getgrid().getTableData().visibleData
					// 		let data = {}
					// 		data.main = submitData
					// 		data.costorder_detail = detail
					// 		this.createJson(data)
					// 		//console.log(data,123123)
					// 		this.$emit('success', {
					// 			data: JSON.stringify(data)
					// 		})
					// 		this.modal_cancel()
					// 		console.log(data)
					// 	} else {
							// for (let i in res) {
							// 	console.log(res[i][0].rule)
							// 	let content = res[i][0].rule.$options.content
							// 	let message = res[i][0].rule.$options.message
							// 	if(content){
							// 		this.$message.error(content)
							// 	}else if(message){
							// 		this.$message.error(message)
							// 	}else{
							// 		this.$message.error('缺少必填项：' + res[i][0].column.title)
							// 	}
								
							// }
					// 	}
					// })
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>